module.exports = __webpack_public_path__ + "img/dialog-bg.d4cf6137.png";